import axios from "axios";
import employees from "../../models/permisosDeAcceso/employees";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getEmployees(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/dcapermisoempleados/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return employees.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      permisoId: items.permissionId,
      fecDesde: items.from + "T00:00:00.000Z",
      fecHasta: items.to == null ? undefined : items.to + "T00:00:00.000Z",
      segmId: items.segment,
      segmDespl: parseInt(items.initialDay, 10),
      emps: items.employees,
    };
    return axios.post(`${url}/dcapermisoempleados`, payload, { headers });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      fecDesde: data.from + "T00:00:00.000Z",
      fecHasta: data.to == null ? undefined : data.to + "T00:00:00.000Z",
      haNoEx: data.to == null ? true : false,
      segmId: data.segment,
      segmDespl: parseInt(data.initialDay, 10),
    };

    return axios
      .patch(
        `${url}/dcapermisoempleados/${data.id}&${data.permissionId}&${data.from}`,
        payload,
        { headers }
      )
      .then(() => {});
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/dcapermisoempleados/${data.id}&${data.permissionId}&${data.from}`,
      { headers }
    );
  }
}
export default service;
